export const SEND_SMS_REQUESTING = "SEND_SMS_REQUESTING";
export const SEND_SMS_SUCCESS = "SEND_SMS_SUCCESS";
export const SEND_SMS_ERROR = "SEND_SMS_ERROR";